'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ProbeLogo = require('./components/ProbeLogo.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ProbeLogo).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-probe-logo/lib/index.js
// module id = 548
// module chunks = 1